import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	flagTitle: {
		id: 'help-center-custom-domain-change-boarding.flag-inner.flag-title',
		defaultMessage: 'Admin has set a new help center URL',
		description: 'Title for custom domain change boarding flag',
	},
	flagDescription: {
		id: 'help-center-custom-domain-change-boarding.flag-inner.flag-description',
		defaultMessage:
			'Discover the new URL under {boldStart}Channels{boldEnd}. Customers using the previous URL will be redirected to the new one.',
		description: 'Description for custom domain change boarding flag',
	},
	flagActionContent: {
		id: 'help-center-custom-domain-change-boarding.flag-inner.flag-action-content',
		defaultMessage: 'Learn more about this change',
		description: 'Link for custom domain change boarding flag',
	},
	flagTitleInactive: {
		id: 'help-center-custom-domain-change-boarding.flag-inner.flag-title-inactive',
		defaultMessage: 'Admin has reverted your help center URL',
		description: 'Title for custom domain deactivation change boarding flag ',
	},
	flagDescriptionInactive: {
		id: 'help-center-custom-domain-change-boarding.flag-inner.flag-description-inactive',
		defaultMessage:
			'Your admin either deactivated or removed the {boldStart}{oldUrl}{boldEnd} custom domain used by this help center. Customers will need to use the default URL {boldStart}{newUrl}{boldEnd}',

		description: 'Description for custom domain deactivation change boarding flag',
	},
	flagActionContentInactive: {
		id: 'help-center-custom-domain-change-boarding.flag-inner.flag-action-content-inactive',
		defaultMessage: 'Learn about deactivated or removed domain',
		description: 'Link for custom domain deactivation change boarding flag',
	},
	flagActionContentInactivateOrRemove: {
		id: 'help-center-custom-domain-change-boarding.flag-inner.flag-action-content-inactivate-or-remove',
		defaultMessage: 'About inactive and removed domains',
		description:
			'Link for custom domain deactivation or removed change boarding flag. The translation to any language cannot exceed 46 characters to avoid flag action being too long',
	},
});
